import { Grid } from '@material-ui/core'
import { metodoPrograma } from '../../components/api'
import Programa from '../../components/Programa/Programa'
import React, { useEffect, useState } from 'react'

export const Dashboard = () => {
  const [cards, setCards] = useState([])

  useEffect(() => {
    metodoPrograma('inic').then((res) => setCards(res.cards || []))
  }, [])

  return (
    <Programa codigo="Dashboard">
      <Grid container spacing={2}>
        {cards.map((card, i) => (
          <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
            <div className={`small-box bg-${card[1]}`}>
              <div className="inner">
                <h3>{card[3]}</h3>
                <p>{card[0]}</p>
              </div>
              <div className="icon">
                <i className={card[2]}></i>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </Programa>
  )
}
